module.exports = __webpack_public_path__ + "img/logo-light.f380d47e.png";